var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-settings-sidebar',{attrs:{"temporary":_vm.temporarySidebar},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-classification-selector'),_c('v-feature-selector'),_c('v-brand-selector')],1)}
var staticRenderFns = []

export { render, staticRenderFns }